import shipvistaAPI from "./shipvistaAPI";

export const getPricingPlans = () => {
  return shipvistaAPI.get(`/subscription/GetAllSubScriptionPlans`);
};
